<template>
    <div class="timeline-event-documents">
        <a :href="document_url(document)" class="timeline-event-documents__document" v-for="document in documents"
            :key="document.id" target="_blank" :class="{ signed: document.is_signed }">
            <img class="timeline-event-documents__thumbnail" v-if="thumbnail_url(document)" :src="thumbnail_url(document)"
                alt="document.title">
            <div class="d-flex align-items-start">
                <img :src="icon_url(document)" class="timeline-event-documents__icon">
                <div class="timeline-event-documents__title">
                    {{ document.title }}
                </div>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    props: ['documents'],
    methods: {
        document_url(document) {
            return `/customer/${document.customer_id}/document/${document.id}/view`;
        },
        thumbnail_url(document) {
            if (document.type == 'document') {
                return `/customer/${document.customer_id}/document/${document.id}/thumbnail`;
            }
            return null;
        },
        icon_url(document) {
            switch (document.type) {
                case 'document':
                    return '/img/file-image.svg';
                default:
                    return '/img/file-pdf.svg';
            }
        }
    }
}
</script>


<style lang="scss" >
.timeline-event-documents {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-flow: row wrap;
    margin: 7.5px -7.5px;

    &__document {
        flex: 0 0 109px;
        box-sizing: border-box;
        background: white;
        border: 2px solid var(--texto-gris, #A6AAB4);
        border-radius: 10px;
        padding: 5px;
        margin: 7.5px;
        display: flex;
        flex-flow: row wrap;
        align-items: flex-start;
        justify-content: flex-start;
        text-decoration: none !important;
        cursor: pointer;
        transition: .3s;

        &:hover {
            color: var(--theme-color);
            border-color: var(--theme-color);
        }

        &.signed {
            box-shadow: 0px 0px 5px 1px rgba(#4abc79, 0.55);
        }
    }

    &__thumbnail {
        flex: 0 0 100%;
        width: 100%;
        margin-bottom: 2px;
        border-radius: 10px;
    }

    &__icon {
        flex: 0 0 16px;
    }

    &__title {
        color: var(--theme-text-color);
        padding: 2px 2px 0 2px;
        line-height: 1;
        font-size: 12px;
        font-weight: bold;
        flex: 0 0 calc(100% - 16px);


    }
}
</style>
